import {Request} from '../utilities/Request';

export function deletePayment(this_obj, id) {
  return Request.delete(
    this_obj,
    `/api/payments/${id}`
  );
}
